// ─── Las clases de una sección, a partir de su horario (g4) ─────────────────
// Sin aula virtual no hay sesiones de syllabus, pero la sección sí sabe cuándo
// se dicta: su horario semanal y sus fechas. De ahí salen las clases del
// calendario del portal, de «Próximos 7 días» y de la suscripción (ICS).
//
// Reglas, sin inventar nada:
//  - Una ocurrencia por semana y por bloque, entre el inicio y el término de la
//    sección (o, si no los tiene, los del período). Sin fechas, no hay clases.
//  - Las horas son de RELOJ en la zona horaria del seminario: «19:00» es las
//    19:00 allá, en invierno y en verano. Por eso aquí se trabaja con fechas de
//    calendario (YYYY-MM-DD) y aritmética en UTC, que no tiene cambio de hora:
//    el cambio de horario de verano lo resuelve quien convierte a un instante
//    (el ICS lo declara con TZID).
//  - Un bloque con la hora de término igual a la de inicio —la forma que dejó
//    el importador de LABTS—, sin término, o con un término anterior, sale con
//    `endTime: null`: «solo hora de inicio». No se le inventa una duración.
//  - Un bloque sin día o sin hora de inicio legibles no sale.
const HHMM = /^([01]\d|2[0-3]):[0-5]\d$/;
const YMD = /^\d{4}-\d{2}-\d{2}/;
/** «2026-09-01T12:00:00.000Z» o «2026-09-01» → «2026-09-01»; si no, null. */
export function calendarDate(value) {
    if (typeof value !== 'string')
        return null;
    const m = YMD.exec(value);
    return m ? m[0] : null;
}
function toUtcNoon(ymd) {
    const [y, m, d] = ymd.split('-').map(Number);
    return Date.UTC(y, m - 1, d, 12);
}
function fromUtc(ms) {
    return new Date(ms).toISOString().slice(0, 10);
}
const DAY_MS = 24 * 60 * 60 * 1000;
export function scheduleOccurrences(params) {
    const spanStart = calendarDate(params.spanStart);
    const spanEnd = calendarDate(params.spanEnd);
    const from = calendarDate(params.from);
    const to = calendarDate(params.to);
    if (!spanStart || !spanEnd || !from || !to)
        return [];
    const lo = spanStart > from ? spanStart : from;
    const hi = spanEnd < to ? spanEnd : to;
    if (lo > hi)
        return [];
    const blocks = (params.schedule ?? [])
        .map((b, entryIndex) => ({ b, entryIndex }))
        .filter(({ b }) => Number.isInteger(b.dayOfWeek) &&
        b.dayOfWeek >= 0 &&
        b.dayOfWeek <= 6 &&
        typeof b.startTime === 'string' &&
        HHMM.test(b.startTime));
    if (blocks.length === 0)
        return [];
    const out = [];
    for (let t = toUtcNoon(lo); t <= toUtcNoon(hi); t += DAY_MS) {
        const weekday = new Date(t).getUTCDay();
        for (const { b, entryIndex } of blocks) {
            if (b.dayOfWeek !== weekday)
                continue;
            const startTime = b.startTime;
            const end = typeof b.endTime === 'string' && HHMM.test(b.endTime) ? b.endTime : null;
            out.push({
                date: fromUtc(t),
                startTime,
                endTime: end !== null && end > startTime ? end : null,
                ...(typeof b.location === 'string' && b.location.trim()
                    ? { location: b.location.trim() }
                    : {}),
                entryIndex,
            });
        }
    }
    return out.sort((a, b) => a.date === b.date ? a.startTime.localeCompare(b.startTime) : a.date.localeCompare(b.date));
}
//# sourceMappingURL=schedule-occurrences.js.map